/**
 * The whole routing table (spec-web-ui §3: "~30 eilučių history routing,
 * be router lib"): two views — the browse screen and an artifact deep link
 * (R23 saugiklis, deep-link nuo pirmos dienos). Parsing is pure and
 * unit-tested (test/ui/router.test.ts); the history glue (pushState +
 * popstate) lives in the shell (ui/entry/browser.ts).
 */

export type Route =
  | { view: "browse"; artifactId: null }
  | { view: "artifact"; artifactId: string };

const ARTIFACT_PATH_RE = /^\/artifacts\/([A-Za-z0-9-]+)\/?$/;

/** pathname → route. Anything unrecognized lands on the browse view; the
 * shell then compares the pathname against {@link canonicalPath} and
 * REPLACES the URL (history.replaceState) on any mismatch, so history
 * stays truthful (ui/entry/browser.ts syncRouteFromLocation). */
export function parseRoute(pathname: string): Route {
  const match = ARTIFACT_PATH_RE.exec(pathname);
  if (match) return { view: "artifact", artifactId: match[1]! };
  return { view: "browse", artifactId: null };
}

/** The ONE pathname a route renders under — the shell's replaceState
 * target: unknown paths normalize to "/", trailing-slash deep links to
 * their exact /artifacts/:id form. */
export function canonicalPath(route: Route): string {
  return route.view === "artifact" ? artifactPath(route.artifactId) : browsePath();
}

export function browsePath(): string {
  return "/";
}

export function artifactPath(artifactId: string): string {
  return `/artifacts/${encodeURIComponent(artifactId)}`;
}
